import React, {useState, useEffect} from "react";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {Calendar} from "primereact/calendar";
import {AutoComplete} from "primereact/autocomplete";
import {RadioButton} from "primereact/radiobutton";
import {ScrollPanel} from "primereact/scrollpanel";
import {base, partnersIndividual, partnersLegal, partnersPhysical, projects_url} from "../../api";
import axios from "axios";
import {useNavigate} from "react-router-dom";

const FILTER_OPTIONS = [
	{label: "Ծրագրեր", value: "programs"},
	{label: "Փաստաթղթավորում", value: "documentation"},
	{label: "Գնումների գործընթաց", value: "procurement"},
	{label: "Հաշվետվություն", value: "reporting"},
	{label: "Գործընկերներ", value: "partners"},
	{label: "Աշխատակիցներ", value: "employees"},
	{label: "Շահառուներ", value: "beneficiaries"},
	{label: "Կամավորներ", value: "volunteers"},
];

const PARTNER_TYPES = [
	{label: "Ֆիզիկական անձ", value: "physical"},
	{label: "Անհատ ձեռներեց", value: "individual"},
	{label: "Կազմակերպություն", value: "legal"},
];

export default function FilterDialog({isFilterVisible, setIsFilterVisible}) {
	const navigate = useNavigate();

	const [selectedCategory, setSelectedCategory] = useState("programs");
	const [selectedPartnerType, setSelectedPartnerType] = useState(null);
	const [partnersResults, setPartnersResults] = useState([]);
	const [projectsResults, setProjectsResults] = useState([]);
	const [autoCompleteValue, setAutoCompleteValue] = useState("");
	const [filteredValues, setFilteredValues] = useState([]);
	const [dateFrom, setDateFrom] = useState(null);
	const [dateTo, setDateTo] = useState(null);

	useEffect(() => {
		if (selectedCategory === "programs") {
			axios.get(base + projects_url).then(res => {
				setProjectsResults(res.data);
				setFilteredValues(res.data);
			});
		}
	}, []);

	const handleCategorySelect = async value => {
		setSelectedCategory(value);
		setAutoCompleteValue("");
		setSelectedPartnerType(null);
		setPartnersResults([]);
		setProjectsResults([]);
		setFilteredValues([]);
		setDateFrom(null);
		setDateTo(null);

		if (value === "programs") {
			const res = await axios.get(base + projects_url);
			setProjectsResults(res.data);
			setFilteredValues(res.data);
		}
	};

	const handlePartnerTypeSelect = async value => {
		setSelectedPartnerType(value);
		let url;
		if (value === "physical") url = partnersPhysical;
		if (value === "individual") url = partnersIndividual;
		if (value === "legal") url = partnersLegal;
		const res = await axios.get(base + url);
		setPartnersResults(res.data);
	};

	const handleAutoComplete = event => {
		const query = event.query.toLowerCase();
		let filtered = [];

		if (selectedCategory === "partners") {
			filtered = partnersResults.filter(
				i =>
					i.full_name_am?.toLowerCase().includes(query) || i.phone?.toLowerCase().includes(query),
			);
		}

		if (selectedCategory === "programs") {
			if (query) {
				filtered = projectsResults.filter(
					i =>
						i.full_name_am?.toLowerCase().includes(query) ||
						i.full_name_en?.toLowerCase().includes(query),
				);
			} else if (dateFrom || dateTo) {
				filtered = projectsResults.filter(i => {
					if (!i.start_date) return false;
					const d = new Date(i.start_date);
					if (dateFrom && d < dateFrom) return false;
					if (dateTo && d > dateTo) return false;
					return true;
				});
			} else {
				filtered = [...projectsResults];
			}
		}

		setFilteredValues(filtered);
	};
	const handleApplyFilters = () => setIsFilterVisible(false);

	const openPartnerDetails = id => navigate(`/partners/${id}`);
	const openProjectDetails = id => {
		navigate(`/project/${id}`);
		setIsFilterVisible(false);
	};

	return (
		<Dialog
			header="Ընդհանուր որոնում"
			visible={isFilterVisible}
			className="col-11 col-md-8 col-lg-7 mx-auto border-0"
			onHide={() => setIsFilterVisible(false)}
			draggable={false}
			closable={false}
			modal>
			<div className="row">
				<div className="col-4">
					<label className="fs-5 text-uppercase opacity-50 border-bottom w-100 mb-3">
						Կատեգորիաներ
					</label>
					<div className="d-flex flex-wrap">
						{FILTER_OPTIONS.map(opt => (
							<div className="col-12 p-0" key={opt.value}>
								<Button
									label={opt.label}
									text
									className={`w-100 px-1 py-2 text-start ${
										selectedCategory === opt.value ? "ps-3 text-primary" : "text-muted"
									}`}
									onClick={() => handleCategorySelect(opt.value)}
								/>
							</div>
						))}
					</div>
				</div>

				<div className="col-8 p-0">
					{selectedCategory === "partners" && (
						<div className="col">
							<div className="mb-5">
								<label className="fs-5 text-uppercase opacity-50 border-bottom w-100 mb-3">
									Ընտրեք տիպը
								</label>
								<div className="d-flex flex-wrap gap-3 my-3">
									{PARTNER_TYPES.map(t => (
										<div key={t.value} className="flex align-items-center gap-2">
											<RadioButton
												inputId={t.value}
												name="partnerType"
												value={t.value}
												onChange={e => handlePartnerTypeSelect(e.value)}
												checked={selectedPartnerType === t.value}
											/>
											<label htmlFor={t.value}>{t.label}</label>
										</div>
									))}
								</div>
							</div>

							{selectedPartnerType && (
								<div className="mb-5">
									<label className="fs-5 text-uppercase opacity-50 border-bottom w-100 mb-3">
										Անուն
									</label>
									<AutoComplete
										value={autoCompleteValue}
										suggestions={filteredValues}
										completeMethod={handleAutoComplete}
										field="full_name_am"
										onChange={e => setAutoCompleteValue(e.value)}
										onSelect={e => openPartnerDetails(e.value.id)}
										itemTemplate={i => (
											<div style={{borderBottom: "1px solid #eee", width: "300px"}} className="p-2">
												<div className="fw-bold">{i.full_name_am}</div>
												<div className="small opacity-75">{i.phone}</div>
												<div className="small opacity-75">{i.email}</div>
											</div>
										)}
										dropdown
										placeholder="Մուտքագրեք անուն կամ հեռախոսահամար"
										className="w-100"
									/>
								</div>
							)}
						</div>
					)}

					{selectedCategory === "programs" && (
						<div className="col">
							<div className="mb-5">
								<label className="fs-5 text-uppercase opacity-50 border-bottom w-100 mb-3">
									Ծրագրեր
								</label>
								<AutoComplete
									value={autoCompleteValue}
									suggestions={filteredValues}
									completeMethod={handleAutoComplete}
									field="full_name_am"
									onChange={e => setAutoCompleteValue(e.value)}
									onSelect={e => openProjectDetails(e.value.id)}
									itemTemplate={i => (
										<div style={{borderBottom: "1px solid #eee", width: "300px"}} className="p-2">
											<div className="fw-bold text-truncate">
												{i.full_name_am || i.full_name_en}
											</div>
											<div className="small opacity-75">{i.number}</div>
											<div className="small opacity-75">
												{i.start_date ? new Date(i.start_date).toLocaleDateString() : "Սկիզբ չկա"}
												{i.currency?.title_am ? ` | ${i.currency.title_am}` : ""}
											</div>
										</div>
									)}
									dropdown
									placeholder="Մուտքագրեք ծրագիր կամ թողեք դատարկ"
									className="w-100"
								/>
							</div>

							<div className="mb-5">
								<label className="fs-5 text-uppercase opacity-50 border-bottom w-100 mb-3">
									Ժամանակահատված
								</label>
								<div className="d-flex gap-2 flex-column flex-md-row">
									<Calendar
										value={dateFrom}
										onChange={e => {
											setDateFrom(e.value);
											handleAutoComplete({query: autoCompleteValue});
										}}
										placeholder="Սկիզած"
										readOnlyInput
										showIcon
										className="w-100"
									/>
									<Calendar
										value={dateTo}
										onChange={e => {
											setDateTo(e.value);
											handleAutoComplete({query: autoCompleteValue});
										}}
										placeholder="Մինչև"
										readOnlyInput
										showIcon
										className="w-100"
									/>
								</div>
							</div>

							{(dateFrom || dateTo) && (
								<div className="mb-5">
									<label className="fs-5 text-uppercase opacity-50 border-bottom w-100 mb-3">
										Նախագծեր {filteredValues?.length || 0} հատ
									</label>
									<ScrollPanel style={{width: "100%", height: "200px"}}>
										{filteredValues.length ? (
											filteredValues.map(p => (
												<div
													key={p.id}
													onClick={() => openProjectDetails(p.id)}
													className="p-2 cursor-pointer border-bottom">
													<div className="fw-bold text-truncate">
														{p.full_name_am || p.full_name_en}
													</div>
													<div className="small opacity-75">{p.number}</div>
													<div className="small opacity-75">
														{p.start_date
															? new Date(p.start_date).toLocaleDateString()
															: "Սկիզբ չկա"}
														{p.currency?.title_am ? ` | ${p.currency.title_am}` : ""}
													</div>
												</div>
											))
										) : (
											<div className="text-center text-muted py-4">Ծրագիր չի գտնվել</div>
										)}
									</ScrollPanel>
								</div>
							)}
						</div>
					)}

					{selectedCategory !== "partners" && selectedCategory !== "programs" && (
						<div className="col">
							<div className="mb-5">
								<label className="fs-5 text-uppercase opacity-50 border-bottom w-100 mb-3">
									Ժամանակահատված
								</label>
								<div className="d-flex gap-2 flex-column flex-md-row">
									<Calendar
										value={dateFrom}
										onChange={e => setDateFrom(e.value)}
										placeholder="Սկիզած"
										readOnlyInput
										showIcon
										className="w-100"
									/>
									<Calendar
										value={dateTo}
										onChange={e => setDateTo(e.value)}
										placeholder="Մինչև"
										readOnlyInput
										showIcon
										className="w-100"
									/>
								</div>
							</div>
						</div>
					)}
				</div>

				<div className="d-flex justify-content-center gap-2">
					<Button
						label="Չեղարկել"
						rounded
						outlined
						severity="secondary"
						className="w-auto"
						onClick={() => setIsFilterVisible(false)}
					/>
					<Button
						label="Որոնել"
						rounded
						severity="primary"
						className="w-auto"
						onClick={handleApplyFilters}
					/>
				</div>
			</div>
		</Dialog>
	);
}
